module.exports = __webpack_public_path__ + "img/CPC.f57aa6fe.svg";